/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { MrfiktivHttpClientProvider } from "../../mrfiktiv-http-client.provider";
import {
  MrfiktivFleetVehicleControllerGetAllParamsGen,
  MrfiktivMultipleIdsDtoOptionalGen
} from "../../v1/data-contracts";
import { FleetVehicles } from "../../v1/FleetVehicles";

export class VehicleFleetService {
  /**
   * The proxy.
   */
  proxy: FleetVehicles;

  /**
   * @class Initialize ReportMeService
   */
  constructor(clientProvider: MrfiktivHttpClientProvider) {
    this.proxy = new FleetVehicles(clientProvider.client());
  }

  async findAll(query: MrfiktivFleetVehicleControllerGetAllParamsGen, data: MrfiktivMultipleIdsDtoOptionalGen) {
    return (await this.proxy.fleetVehicleControllerGetAllPost(query, data)).data;
  }

  findOne(partnerId: string, fleetId: string, id: string) {
    return this.proxy.fleetVehicleControllerGetOne(partnerId, fleetId, id);
  }
}

export default new VehicleFleetService(new MrfiktivHttpClientProvider());
